import Modal from 'react-overlays/Modal'
import Dropdown from 'react-dropdown'
import UpgradeLayout from './upgrade-layout'
import useAbility from '@/hooks/use-ability'
import { showRanchLimitToast } from './toast/ranch-limit-toast'
import { useAuthStore } from './PrivateRoute'
import { useEffect } from 'react'
import { ETierKey } from '@/pages/subscribe/_data/subscribe-constant'
import { useQueryState } from 'nuqs'
import {
  TrialLimitType,
  TRIAL_LIMIT_QUERY_KEY,
} from './trial-modal/trial-limit-modal'

export default function RanchSelectModal({
  selectedRanch,
  onChange,
  ranchName,
  onSubmit,
  setSelectedParcelIds,
  showRanchSelectModal,
  setShowRanchSelectModal,
  onRanchDropdownChange,
  ranches,
  addParcelToRanch,
  addInitialParcelToRanch,
  initialRanch,
  setInitialRanch = () => {},
}) {
  const handleClose = () => {
    setSelectedParcelIds([])
    setShowRanchSelectModal(false)
  }

  const [_, setTrialLimitState] = useQueryState(TRIAL_LIMIT_QUERY_KEY)

  const auth = useAuthStore((state) => state)

  const currentTier = auth.tier.includes(' - ')
    ? auth.tier.split(' - ')[0]
    : auth.tier

  const renderBackdrop = (props) => <div className="backdrop" {...props} />

  const { getAbilityLimit, getAbilityOptionalLimit } = useAbility()

  const numberOfRemainingRanches = getAbilityOptionalLimit(
    'number_of_remaining_ranches'
  )
  const numberOfCustomRanches = getAbilityLimit('number_of_custom_ranches')

  const isFreeTrial = currentTier === ETierKey.Trial

  useEffect(() => {
    if (showRanchSelectModal) {
      if (isFreeTrial) return

      if (numberOfRemainingRanches === 0) {
        showRanchLimitToast({
          tier: currentTier,
          numberOfCustomRanches: numberOfCustomRanches,
        })
      }
    }
  }, [numberOfCustomRanches, showRanchSelectModal, currentTier])

  return (
    <>
      <div className="bg-black bg-opacity-50 flex items-center justify-center fixed left-0 right-0 bottom-0 top-0 z-[200]"></div>
      <div>
        <Modal
          className="modal"
          show={showRanchSelectModal}
          onHide={handleClose}
          renderBackdrop={renderBackdrop}
          style={{
            // display: 'flex',
            position: 'absolute',
            top: '50%',
            left: '50%',
            marginTop: '-170px',
            marginLeft: '-140px',
            width: '280px',
            height: '380px',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 1050,
          }}
        >
          <div>
            <div className="modal-header">
              <div className="modal-title">Ranch Selection</div>
              <div>
                <span className="close-button" onClick={handleClose}>
                  x
                </span>
              </div>
            </div>
            <div className="modal-desc">
              <div style={{ height: 270 }}>
                <strong>Ranch</strong>
                <Dropdown
                  options={ranches.map((ranch) => ranch.ranch_name)}
                  onChange={onRanchDropdownChange}
                  placeholder="Select your ranch"
                  value={selectedRanch.ranch_name}
                />
                <button
                  className="mt-2 px-7 py-3 bg-blue-600 text-white font-medium text-sm uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg w-full text-center transition duration-150 ease-in-out btn btn-custom add-to-ranch"
                  style={{ marginTop: '10px' }}
                  onClick={() => {
                    if (!initialRanch) {
                      addParcelToRanch(selectedRanch)
                    } else if (initialRanch == 1)
                      addInitialParcelToRanch(selectedRanch)
                    else addInitialParcelToRanch(selectedRanch, true)
                    setInitialRanch(0)
                  }}
                >
                  Add to This Ranch
                </button>

                <div className="flex items-center my-4 before:border-t before:flex-1 before:border-gray-300 after:border-t after:flex-1 after:border-gray-300 ">
                  <p className="text-center font-semibold mx-4">OR</p>
                </div>

                <div className="w-full relative">
                  <UpgradeLayout
                    title="Upgrade to create new ranch."
                    needUpgrade={
                      numberOfRemainingRanches !== undefined &&
                      numberOfRemainingRanches === 0 &&
                      !isFreeTrial
                    }
                  />
                  <form
                    onSubmit={(e) => {
                      if (isFreeTrial) {
                        if (numberOfRemainingRanches === 0) {
                          setShowRanchSelectModal(false)
                          setTrialLimitState(TrialLimitType.RANCH_LIMIT)
                          return
                        }
                      }

                      if (initialRanch) {
                        e.preventDefault()
                        addInitialParcelToRanch({ ranch_name: ranchName }, true)
                      } else onSubmit(e)
                      setInitialRanch(0)
                    }}
                  >
                    <input
                      className="w-full px-4 py-2 text-xl text-gray-700 bg-white border-gray-300 rounded transition ease-in-out mb-2"
                      type="text"
                      id="ranchName"
                      value={ranchName}
                      onChange={onChange}
                      placeholder="Ranch Name"
                      style={{ fontSize: 16 }}
                    />

                    <button
                      disabled={
                        numberOfRemainingRanches !== undefined &&
                        numberOfRemainingRanches === 0 &&
                        !isFreeTrial
                      }
                      className="px-7 py-3 bg-primary text-white font-medium text-sm uppercase rounded shadow-md hover:bg-[#01589d] hover:shadow-lg focus:bg-[#01589d] focus:shadow-lg w-full text-center transition duration-150 ease-in-out btn btn-custom"
                      type="submit"
                    >
                      Create New Ranch
                    </button>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </div>
    </>
  )
}
